/* ============ Shimco · theme.js ============ */
(function () {
  'use strict';

  var rutas = window.shopRoutes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------- Utilidades ---------- */
  function dinero(centavos) {
    var formato = window.shopMoneyFormat || '${{amount}}';
    var valor = (centavos / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return formato.replace(/\{\{\s*amount\s*\}\}/, valor)
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, valor.split('.')[0]);
  }

  function avisarCarrito(cart) {
    document.dispatchEvent(new CustomEvent('sh:cart:updated', { detail: cart }));
  }

  window.shAgregarAlCarrito = function (variantId, cantidad) {
    return fetch(rutas.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: cantidad || 1 }] })
    })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { avisarCarrito(cart); return cart; });
  };

  window.shCambiarLinea = function (clave, cantidad) {
    return fetch(rutas.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: clave, quantity: cantidad })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { avisarCarrito(cart); return cart; });
  };

  /* ---------- Swatches en tarjetas ---------- */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-shp-swatch]');
    if (!swatch) return;

    var card = swatch.closest('[data-shp-card]');
    if (!card) return;
    var img = card.querySelector('[data-shp-img]');
    var todosLink = card.querySelectorAll('[data-shp-link]');

    if (swatch.dataset.img && img) img.src = swatch.dataset.img;
    if (swatch.dataset.url) todosLink.forEach(function (a) { a.href = swatch.dataset.url; });

    var agregar = card.querySelector('[data-shp-agregar]');
    if (agregar && swatch.dataset.variante) agregar.dataset.shpAgregar = swatch.dataset.variante;

    card.querySelectorAll('[data-shp-swatch]').forEach(function (s) {
      s.classList.toggle('is-active', s === swatch);
    });
  });

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('[data-shp-swatch]');
    if (!swatch || !swatch.dataset.img) return;
    var card = swatch.closest('[data-shp-card]');
    var img = card && card.querySelector('[data-shp-img]');
    if (img) img.src = swatch.dataset.img;
  });

  /* ---------- Aviso flotante ---------- */
  var toast;
  function avisar(texto) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'sh-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = texto;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Cart drawer ---------- */
  var cart = document.querySelector('[data-sh-cart]');

  window.shAbrirCarrito = function () {
    if (!cart) { window.location.href = rutas.cart; return; }
    cart.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  function cerrarCarrito() {
    if (!cart) return;
    cart.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Vuelve a pedir el carrito al servidor y reemplaza el contenido del drawer */
  function refrescarDrawer() {
    if (!cart) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer-refresh')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-refresh'];
        if (!html) return;

        var nuevo = new DOMParser().parseFromString(html, 'text/html');

        var itemsNuevos = nuevo.querySelector('.sh-cart__items');
        var pieNuevo    = nuevo.querySelector('.sh-cart__pie');
        var envioNuevo  = nuevo.querySelector('.sh-cart__envio');

        var itemsActual = cart.querySelector('.sh-cart__items');
        var pieActual   = cart.querySelector('.sh-cart__pie');
        var envioActual = cart.querySelector('.sh-cart__envio');

        if (itemsNuevos && itemsActual) itemsActual.innerHTML = itemsNuevos.innerHTML;
        if (pieNuevo && pieActual) pieActual.innerHTML = pieNuevo.innerHTML;

        if (envioNuevo && envioActual) {
          envioActual.innerHTML = envioNuevo.innerHTML;
        } else if (envioNuevo && !envioActual) {
          cart.querySelector('.sh-cart__head').insertAdjacentHTML('afterend', envioNuevo.outerHTML);
        } else if (!envioNuevo && envioActual) {
          envioActual.remove();
        }
      })
      .catch(function () {});
  }

  function pintarCarrito(data) {
    document.querySelectorAll('[data-sh-cart-count]').forEach(function (n) {
      n.textContent = data.item_count;
    });
    return refrescarDrawer();
  }

  if (cart) {
    cart.querySelectorAll('[data-sh-cart-cerrar]').forEach(function (b) {
      b.addEventListener('click', cerrarCarrito);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cart.classList.contains('is-open')) cerrarCarrito();
    });

    /* El overlay tambien cierra */
    var overlay = cart.querySelector('.sh-cart__overlay');
    if (overlay) overlay.addEventListener('click', cerrarCarrito);

    /* Quitar articulo: usa la clave de la linea, no el indice */
    cart.addEventListener('click', function (e) {
      var quitar = e.target.closest('[data-sh-quitar]');
      if (!quitar) return;
      e.preventDefault();

      var clave = quitar.dataset.shQuitar;
      if (!clave) return;

      quitar.textContent = (window.shTextos || {}).quitando || 'Quitando...';
      quitar.style.pointerEvents = 'none';

      window.shCambiarLinea(clave, 0)
        .then(function () { avisar((window.shTextos || {}).eliminado || 'Producto eliminado'); })
        .catch(function () {
          quitar.textContent = (window.shTextos || {}).quitar || 'Quitar';
          quitar.style.pointerEvents = '';
          avisar((window.shTextos || {}).error_quitar || 'No pudimos quitarlo, intenta de nuevo');
        });
    });
  }

  document.addEventListener('sh:cart:updated', function (e) { pintarCarrito(e.detail); });

  /* ---------- Compra rapida desde la tarjeta ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-shp-agregar]');
    if (!btn) return;
    e.preventDefault();

    var id = btn.dataset.shpAgregar;
    if (!id) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = (window.shTextos || {}).agregando || 'Agregando...';

    window.shAgregarAlCarrito(id, 1)
      .then(function () {
        btn.textContent = (window.shTextos || {}).agregado || 'Agregado';
        btn.classList.add('is-listo');
        avisar((window.shTextos || {}).agregado_aviso || 'Agregado a tu carrito');
        setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove('is-listo');
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
        avisar((window.shTextos || {}).error_agregar || 'No pudimos agregarlo, intenta de nuevo');
      });
  });

  /* ---------- Aparicion al hacer scroll ---------- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && window.innerWidth > 860 && 'IntersectionObserver' in window) {
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('is-in');
          observador.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    var marcar = function () {
      document.querySelectorAll('.shp-grid > *, .sh-quote, .sh-cat, .sh-coldest__head, .sh-nos__valor').forEach(function (el, i) {
        if (el.classList.contains('sh-reveal')) return;
        el.classList.add('sh-reveal');
        el.setAttribute('data-retraso', String(i % 4));
        observador.observe(el);
      });
    };
    marcar();
    document.addEventListener('shopify:section:load', marcar);
  }

  /* ---------- Popup de newsletter ---------- */
  var popup = document.querySelector('[data-sh-popup]');
  if (popup && !sessionStorage.getItem('sh_popup_visto')) {
    setTimeout(function () { popup.classList.add('is-open'); }, 6000);
  }

  window.shAbrirPopup = function () {
    if (popup) popup.classList.add('is-open');
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sh-popup-abrir]')) {
      e.preventDefault();
      window.shAbrirPopup();
    }
  });

  if (popup) {
    popup.querySelectorAll('[data-sh-popup-cerrar]').forEach(function (b) {
      b.addEventListener('click', function () {
        popup.classList.remove('is-open');
        sessionStorage.setItem('sh_popup_visto', '1');
      });
    });
  }
})();